import React from "react";

import styles from './LinearLoader.module.css'

interface Props {
}

export const LinearLoader: React.FC<Props & React.HTMLAttributes<HTMLButtonElement>> = () => {
    return (
        <div className={styles.barContainer}>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
        </div>
    )
}